import { useState, useEffect } from "react";
import { useConsent, isExternalUrl } from "../../../utils/cookieConsent";
import "./Avatar.less";

export function computeInitials(name: string, email?: string): string {
  const trimmed = name.trim();
  if (trimmed) {
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }
  if (email) {
    const emailLocal = email.split("@")[0] ?? "";
    return emailLocal.slice(0, 2).toUpperCase();
  }
  return "?";
}

export function Avatar({
  name,
  image,
  size = 24,
  className,
  "data-testid": testId,
}: {
  name: string;
  image?: string | null;
  size?: number;
  className?: string;
  "data-testid"?: string;
}) {
  const consentAccepted = useConsent();
  const [imageBroken, setImageBroken] = useState(false);
  useEffect(() => {
    setImageBroken(false);
  }, [image]);

  const gatedByConsent = isExternalUrl(image) && !consentAccepted;
  const showImage = !!image && !imageBroken && !gatedByConsent;
  const initials = computeInitials(name);
  const classes = ["avatar", className].filter(Boolean).join(" ");

  return (
    <span
      className={classes}
      style={{ width: size, height: size, fontSize: size * 0.45 }}
      title={name}
      data-testid={testId}
    >
      {showImage ? (
        <img
          src={image!}
          alt=""
          className="avatar__img"
          width={size}
          height={size}
          onError={() => setImageBroken(true)}
        />
      ) : (
        <span className="avatar__initials" aria-hidden="true">
          {initials}
        </span>
      )}
    </span>
  );
}
